import { useLayoutEffect, useRef } from 'react';
import ReactMarkdown from "react-markdown";

export default function AllMarkdown({ getShowExpand, children }) {
    const contentRef = useRef(null);

    useLayoutEffect(() =>  {
        getShowExpand && getShowExpand(contentRef && contentRef.current && (contentRef.current.scrollHeight > contentRef.current.clientHeight))
    }, [contentRef && contentRef.current && contentRef.current.clientHeight])

    return (
      <div ref={contentRef} className="all-markdown">
        <ReactMarkdown 
          components={{
            img: ({ node, ...props }) => ( <img className="w-100 img-fluid" {...props} /> )
          }} >
          {children}
        </ReactMarkdown>
      </div>
    );
}
